<template>
	<div>
		<div class="first_line">
			<div class="right_warp">
				<el-select class="jul" size="small" filterable v-model="filter.name" style="margin-right:3px;"
					placeholder="请选择">
					<el-option v-for="item in statelist" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input v-model="filter.workerName" size="small" placeholder="输入员工名称" style="width: 150px"
					clearable></el-input>
				<el-select v-model="filter.type" size="small" placeholder="全部" style="width: 120px" clearable>
					<el-option label="迟到" value="1"></el-option>
					<el-option label="早退" value="2"></el-option>
					<el-option label="旷工" value="3"></el-option>
				</el-select>
				<el-date-picker v-model="filter.time" :clearable="false" type="daterange" size="small"
					style="margin-left: 10px;margin-right: 25px; width: 250px;" value-format="yyyy-MM-dd"
					range-separator="至">
				</el-date-picker>
				<el-button class="jul" type="primary" @click="getlist" size="small">筛选</el-button>
			</div>
			<div>
				<el-button class="jul" type="primary" @click="exports()" size="small">全部导出</el-button>
			</div>
		</div>
		<div>
			<div class="calendar">
				<el-table :data="list" style="width: 100%"
					:header-cell-style="{background:'#F2F2F4', 'text-align':'center'}"
					:cell-style="{'text-align':'center'}">
					<el-table-column prop="name" label="姓名" />
					<el-table-column prop="storeName" label="门店"></el-table-column>
					<el-table-column prop="date" label="排班"></el-table-column>
					<el-table-column prop="rosterTime" label="排班时长">
						<template slot-scope="scope">
							{{ scope.row.rosterTime ?scope.row.rosterTime :'/' }}
						</template>
					</el-table-column>
					<el-table-column prop="rosterStartAndEnd" label="班次" width="175">
						<template slot-scope="scope">
							{{ scope.row.rosterId==70?"加班": scope.row.rosterStartAndEnd |format1 }}
						</template>
					</el-table-column>
					<el-table-column prop="workerTime" label="工作时长">
						<template slot-scope="scope">
							{{ scope.row.workerTime ?scope.row.workerTime :'/' }}
						</template>
					</el-table-column>
					<el-table-column prop="morningDate" label="上班打卡时间" width="130px">
						<template slot-scope="scope">
							<div v-if="scope.row.edit==false">{{ scope.row.morningDate ?scope.row.morningDate :'/' }}
							</div>
							<!-- <el-input v-else v-model="scope.row.morningDate" ></el-input> -->
							<el-time-picker v-else v-model="scope.row.morningDate" value-format="HH:mm:ss"
								:picker-options="{
							      selectableRange: '08:00:00 - 23:59:00'
							    }" style="width:120px" clearable placeholder="上班打卡时间">
							</el-time-picker>
						</template>
					</el-table-column>
					<el-table-column prop="nightDate" label="下班打卡时间" width="130px">
						<template slot-scope="scope">
							<div v-if="scope.row.edit==false">{{ scope.row.nightDate ?scope.row.nightDate :'/' }}</div>
							<el-time-picker v-else v-model="scope.row.nightDate" value-format="HH:mm:ss"
								:picker-options="{
							      selectableRange: '08:00:00 - 23:59:00'
							    }" style="width:120px" clearable placeholder="下班打卡时间">
							</el-time-picker>
						</template>
					</el-table-column>
					<el-table-column prop="lastTime" label="迟到(分钟)">
						<template slot-scope="scope">
							<span v-if="scope.row.lastTime" :class="scope.row.lastTime > 0?'red':'0'">
								{{ scope.row.lastTime != null && scope.row.lastTime > 0 ?scope.row.lastTime :0 }}
							</span>
							<span v-else>/</span>
						</template>
					</el-table-column>
					<el-table-column prop="beforeTime" label="早退(分钟)">
						<template slot-scope="scope">
							<span v-if="scope.row.beforeTime" :class="scope.row.beforeTime > 0?'red':'0'">
								{{ scope.row.beforeTime != null && scope.row.beforeTime > 0 ?scope.row.beforeTime :0 }}
							</span>
							<span v-else>/</span>
						</template>
					</el-table-column>
					<el-table-column prop="absenteeism" label="旷工">
						<template slot-scope="scope">
							{{ scope.row.absenteeism?'旷工' :'无' }}
						</template>
					</el-table-column>
					<el-table-column prop="morningImg" label="上班照">
						<template slot-scope="scope">
							<el-image style="width:60px" :src="scope.row.morningImg"
								:preview-src-list=[scope.row.morningImg]> </el-image>
						</template>
					</el-table-column>
					<el-table-column prop="nightImg" label="下班照">
						<template slot-scope="scope">
							<el-image style="width:60px" :src="scope.row.nightImg"
								:preview-src-list=[scope.row.nightImg]> </el-image>
						</template>
					</el-table-column>
					<el-table-column width="175">
						<template slot-scope="scope">
							<!-- <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="imgList" /> -->
							<!-- <el-button type="text" @click="onPreview(scope.row.morningImg,scope.row.nightImg)">查看拍照</el-button> -->
							<el-button type="text" v-if="scope.row.edit==false"
								@click="edit(scope.row)">修改打卡</el-button>
							<el-button type="text" v-else @click="save(scope.row)">保存修改</el-button>
						</template>
					</el-table-column>
					<el-table-column v-for="(item,index) in dates" :key="index" prop="total"
						:label="item.split('-').slice(1).join('-')">
						<template slot-scope="scope">
							<span v-for="(item1,index1) in scope.row.dates" :key="index1">
								<template v-if="item1.date === item">
									{{ item1.color }}
								</template>
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagechange">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="filter.pageNum" :page-sizes="[10,20,50]" :page-size="filter.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>
<script>
	import {
		parseTime,
		url
	} from "../../../utils/index.js"
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
	export default {
		components: {
			ElImageViewer
		},
		data() {
			return {
				url: url(),
				total: 0,
				list: [],
				dates: [],

				filter: {
					time: [new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
							.getMonth() + 1) : (new Date().getMonth() + 1)) + '-' + ((new Date().getDate()) < 10 ?
							'0' + (new Date()
								.getDate()) : new Date().getDate()),
						new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
							.getMonth() + 1) : (new Date().getMonth() + 1)) + '-' + ((new Date().getDate()) < 10 ?
							'0' + (new Date()
								.getDate()) : new Date().getDate())
					],
					pageNum: 1,
					pageSize: 10,
					name: undefined,
					type: "",
					workerName: ""
				},
				showViewer: false,
				times: "",
				timeVal: "",
				storeval: [],
				imgList: [],
				statelist: [{
					value: undefined,
					label: "全部门店"
				}],
			};
		},
		mounted() {
			this.getstorelist();
			this.getlist();
			console.log(this.filter.time[0])
		},
		filters: {
			format1(val) {
				switch (val) {
					case '10:00:00-18:10:00':
						return "请假";
					case '00:00:00-23:59:59':
						return "调休";
					case '10:00:00-23:59:00':
						return "疫情居家";
					default:
						return val;
				}
			},
			format2(val) {
				switch (val) {
					case 0:
						return "事假";
					case 1:
						return "病假";
					case 2:
						return "年假";
					case 3:
						return "产假";
					case 4:
						return "陪产假";
					case 5:
						return "婚假";
					case 6:
						return "丧假";
					default:
						return val;
				}
			}
		},
		methods: {
			edit(row) {
				row.edit = true
			},
			save(row) {
				var a = {
					morningId: row.morningId,
					nightId: row.nightId,
					startTime: row.morningDate,
					endTime: row.nightDate,
					rosterStartAndEnd: row.rosterStartAndEnd,
					date: row.date,
					workerId: row.workerId,
					storeId: row.storeId
				}
				this.$http.post("dcheckuser/updateDCheckUser", JSON.stringify(a)).then((res) => {
					this.getlist();
				})
				row.edit = false
			},
			//考情列表导出
			exports() {
				var urls = this.url + "dcheckuser/exporDCheckUser?startTime=" + this.filter.time[0] + "&endTime=" + this
					.filter.time[1];
				if (this.filter.name != null && this.filter.name != undefined) urls += "&name=" + this.filter.name;
				if (this.filter.workerName != "" && this.filter.workerName != null) urls += "&workerName=" + this.filter
					.workerName;
				if (this.filter.type != "" && this.filter.type != null) urls += "&type=" + this.filter.type;
				window.location.assign(urls)
			},
			getlist() {
				var a = {
					pageNum: this.filter.pageNum,
					pageSize: this.filter.pageSize,
					name: this.filter.name,
					type: this.filter.type,
					workerName: this.filter.workerName
				}
				if (this.filter.time) {
					a.startTime = this.filter.time[0],
						a.endTime = this.filter.time[1]
				}
				this.$http.post("dcheckuser/findDCheckUser", JSON.stringify(a)).then((res) => {
					if (res.body.code == 200) {
						this.list = res.body.data
						this.total = res.body.total
						this.list.forEach(d => {
							this.$set(d, "edit", false)
						})
					}
				})
			},
			getstorelist() {
				this.$http.get("store/list").then((res) => {
					if (res.body.code == 200) {
						res.body.data.forEach(ele => {
							if (ele.businessType == 0) this.statelist.push({
								value: ele.title,
								label: ele.title
							})
						});
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			onPreview(morningImg, nightImg) {
				this.showViewer = true
				this.imgList[0] = morningImg
				this.imgList[1] = nightImg
			},
			closeViewer() {
				this.showViewer = false
			},
			handleSizeChange(val) {
				this.filter.pageSize = val
				this.getlist()
			},
			handleCurrentChange(val) {
				this.filter.pageNum = val
				this.getlist()
			},
		},
	};
</script>
<style lang="less" scoped>
	.red {
		color: red;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.pagechange {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>